import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { UserActionTypes } from "../models";
import { LOGOUT } from "../types";

export default () => async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        await api.post("/logout");
        dispatch({
            type: LOGOUT,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
    }
};
